{
  "list": {
    "title": "Устройства",
    "addNew": "+ Новое устройство",
    "confirm": {
      "delete": "Удалить устройство {{name}} (SN: {{serial}})? История посещаемости будет сохранена, но терминал перестанет распознаваться."
    },
    "pendingActivation_one": "{{count}} устройство ожидает активации.",
    "pendingActivation_few": "{{count}} устройства ожидают активации.",
    "pendingActivation_many": "{{count}} устройств ожидают активации.",
    "pendingActivation_other": "{{count}} устройства ожидают активации.",
    "failedToLoad": "Не удалось загрузить данные. Пожалуйста, попробуйте снова.",
    "empty": "Устройств пока нет. Нажмите + Новое устройство для добавления.",
    "activate": "Активировать",
    "columns": {
      "serial": "Серийный номер",
      "name": "Имя",
      "description": "Описание",
      "status": "Статус",
      "users": "Пользователи",
      "logs": "Журнал",
      "lastSeen": "Последний раз в сети",
      "actions": "Действия"
    },
    "badges": {
      "pending": "Ожидает",
      "pendingCommands_one": "{{count}} команда ожидает доставки",
      "pendingCommands_few": "{{count}} команды ожидают доставки",
      "pendingCommands_many": "{{count}} команд ожидают доставки",
      "pendingCommands_other": "{{count}} команды ожидают доставки"
    },
    "aria": {
      "deactivate": "Деактивировать устройство",
      "activate": "Активировать устройство",
      "notManaged": "Вы не управляете этим устройством"
    }
  },
  "detail": {
    "accessDenied": "Доступ запрещён",
    "accessDeniedHint": "У вас нет прав для просмотра этого устройства.",
    "backToDevices": "Назад к устройствам",
    "notFound": "Устройство не найдено",
    "failedToLoad": "Не удалось загрузить устройство. Пожалуйста, попробуйте снова.",
    "breadcrumb": "Устройства",
    "importAll": "Импортировать всех с терминала",
    "importing": "Импорт…",
    "exportAll": "Экспортировать всех на терминал",
    "exporting": "Экспорт…",
    "pushSettings": "Отправить все настройки сейчас",
    "pushingSettings": "Отправка…",
    "pushSettingsSuccess_one": "{{count}} команда поставлена в очередь.",
    "pushSettingsSuccess_few": "{{count}} команды поставлены в очередь.",
    "pushSettingsSuccess_many": "{{count}} команд поставлено в очередь.",
    "pushSettingsSuccess_other": "{{count}} команды поставлено в очередь.",
    "pendingCommands_one": "{{count}} команда ожидает доставки на терминал",
    "pendingCommands_few": "{{count}} команды ожидают доставки на терминал",
    "pendingCommands_many": "{{count}} команд ожидают доставки на терминал",
    "pendingCommands_other": "{{count}} команды ожидают доставки на терминал",
    "addExisting": "+ Добавить существующего",
    "addNew": "+ Новый сотрудник",
    "editDevice": "Изменить устройство",
    "clearHistory": "Очистить историю на терминале",
    "clearing": "Очистка…",
    "ownerLabel": "Владелец:",
    "lastSeenLabel": "Последний раз в сети:",
    "employees": "Сотрудники",
    "searchPlaceholder": "Поиск...",
    "failedToLoadEmployees": "Не удалось загрузить сотрудников. Пожалуйста, попробуйте снова.",
    "noEmployeesSearch": "Сотрудники не найдены.",
    "noEmployeesEmpty": "На этом устройстве пока нет зарегистрированных сотрудников.",
    "columns": {
      "deviceUserId": "ID пользователя устройства",
      "name": "Имя",
      "role": "Роль",
      "card": "Карта",
      "status": "Статус",
      "lastSynced": "Последняя синхронизация",
      "lastSeenHere": "Последний раз здесь",
      "syncState": "Состояние синхронизации"
    },
    "syncBadges": {
      "synced": "Синхронизировано",
      "sent": "Отправлено",
      "pending": "Ожидает",
      "removing": "Удаляется",
      "removed": "Удалено"
    },
    "actions": {
      "edit": "Изменить",
      "export": "Экспорт",
      "unenroll": "Отписать"
    },
    "confirm": {
      "importAll": "Импортировать всех сотрудников с терминала? Совпадающие записи будут перезаписаны.",
      "exportAll": "Экспортировать всех сотрудников на терминал? Все активные сотрудники будут отправлены на устройство.",
      "clearHistory": "Очистить всю историю отметок на терминале? Это действие нельзя отменить.",
      "unenroll": "Удалить этого сотрудника с устройства?",
      "importQueue": "Поставить в очередь команду DATA QUERY для загрузки всех пользователей с этого терминала?",
      "exportAllDetail": "Отправить всех зарегистрированных сотрудников (USERINFO + фото + биометрические шаблоны) на этот терминал?",
      "clearHistorySwipes": "Это безвозвратно удалит всю историю отметок на терминале «{{name}}».\n\nЛокальные записи в приложении будут сохранены.\n\nПродолжить?",
      "clearHistoryPhotos": "Также удалить фото посещаемости с терминала?\n\nНажмите OK, чтобы очистить фото, Отмена — чтобы оставить их.",
      "unenrollDetail": "Отписать «{{name}}» (PIN {{pin}}) с этого устройства?\n\nСотрудник и его история посещаемости не будут удалены. Будет поставлена в очередь команда DATA DELETE USERINFO."
    },
    "unenrollFailed": "Не удалось отписать. Пожалуйста, попробуйте снова.",
    "importQueued": "В очередь добавлено {{count}} команд(ы). {{message}}",
    "importFailed": "Импорт не удался. Убедитесь, что терминал в сети.",
    "exportQueued": "Экспорт поставлен в очередь для {{employees}} сотрудника(-ов):\n• {{userinfo}} записей пользователей\n• {{userpic}} фото\n• {{biometric}} биометрических шаблонов\n\n{{message}}",
    "exportFailed": "Экспорт не удался.",
    "clearHistoryFailed": "Не удалось очистить историю.",
    "pushSettingsFailed": "Не удалось отправить настройки.",
    "exportOneQueued": "Поставлено в очередь для {{name}} (PIN {{pin}}) на {{devices}} устройстве(-ах).",
    "titlePullUsers": "Загрузить пользователей, фото и биометрические шаблоны с этого терминала",
    "titleRestoreDB": "Восстановить содержимое локальной БД и MinIO на этот терминал",
    "titlePushSettings": "Отправить все сохранённые настройки оборудования на терминал",
    "titleWipeHistory": "Удалить историю отметок, хранящуюся на терминале. Локальная БД сохраняется.",
    "roleFallbackUser": "Пользователь",
    "aria": {
      "searchEmployees": "Поиск сотрудников",
      "loadingEmployees": "Загрузка сотрудников..."
    }
  },
  "editDialog": {
    "titleNew": "Новое устройство",
    "titleEdit": "Изменить устройство — {{name}}",
    "serialLabel": "Серийный номер",
    "serialHint": "Привязан к физическому терминалу. Изменить нельзя.",
    "nameLabel": "Имя",
    "descriptionLabel": "Описание (необязательно)",
    "descriptionPlaceholder": "Местоположение или заметки об этом терминале…",
    "ownerLabel": "Владелец",
    "activeLabel": "Активно",
    "saveFailed": "Не удалось сохранить",
    "hardware": {
      "title": "Настройки терминала",
      "tzAdj": "Смещение часового пояса (мин от UTC)",
      "verifyMode": "Режим верификации",
      "verifyModeOptions": {
        "0": "Любой способ (по умолчанию)",
        "1": "Только отпечаток",
        "4": "Только карта",
        "6": "Отпечаток или карта",
        "15": "Только лицо"
      },
      "verifyModeHint": "Действует для всех сотрудников этого терминала; при смене режима их записи отправляются на устройство заново.",
      "lockOn": "Длительность реле замка (с)",
      "volume": "Громкость динамика",
      "idlePower": "Автовыключение при простое (мин, 0 = выкл)",
      "idleMinute": "Таймер режима сна (мин, 0 = выкл)",
      "lockFun": "Функция дверного замка",
      "punchAlarm": "Аванс сигнала отметки (мин)",
      "mustEnroll": "Только зарегистрированные пользователи"
    }
  },
  "enrollDialog": {
    "title": "Добавить существующих сотрудников",
    "searchPlaceholder": "Поиск по имени или PIN...",
    "allEnrolled": "Все сотрудники уже зарегистрированы на этом устройстве.",
    "noResults": "Сотрудники не найдены.",
    "noneSelected": "Ничего не выбрано",
    "countSelected_one": "Выбран {{count}}",
    "countSelected_few": "Выбрано {{count}}",
    "countSelected_many": "Выбрано {{count}}",
    "countSelected_other": "Выбрано {{count}}",
    "enrolling": "Регистрация…",
    "enroll_one": "Зарегистрировать {{count}}",
    "enroll_few": "Зарегистрировать {{count}}",
    "enroll_many": "Зарегистрировать {{count}}",
    "enroll_other": "Зарегистрировать {{count}}",
    "columns": {
      "pin": "PIN",
      "name": "Имя"
    },
    "enrollFailed": "Ошибка регистрации",
    "enrollSuccess_one": "Зарегистрирован {{count}} сотрудник. В очереди {{queued}} команд для терминала.",
    "enrollSuccess_few": "Зарегистрировано {{count}} сотрудника. В очереди {{queued}} команд для терминала.",
    "enrollSuccess_many": "Зарегистрировано {{count}} сотрудников. В очереди {{queued}} команд для терминала.",
    "enrollSuccess_other": "Зарегистрировано {{count}} сотрудника. В очереди {{queued}} команд для терминала."
  },
  "selectTerminalsDialog": {
    "title": "Выбор терминалов",
    "subtitle": "Выберите терминалы",
    "confirm": "Экспортировать",
    "importConfirm": "Импортировать",
    "noActiveTerminals": "Нет активных терминалов",
    "selectAll": "Выбрать все",
    "deselectAll": "Снять все",
    "noneSelected": "Ничего не выбрано",
    "countSelected_one": "Выбран {{count}}",
    "countSelected_few": "Выбрано {{count}}",
    "countSelected_many": "Выбрано {{count}}",
    "countSelected_other": "Выбрано {{count}}"
  },
  "terminalUsers": {
    "title": "Сотрудники",
    "importAll": "Импортировать всех с терминала",
    "exportAll": "Экспортировать всех на терминал",
    "addNew": "+ Новый сотрудник",
    "searchPlaceholder": "Поиск по имени или PIN…",
    "filters": {
      "status": "Статус",
      "statusAll": "Все",
      "statusActive": "Активные",
      "statusInactive": "Неактивные",
      "role": "Роль",
      "roleUser": "Пользователь",
      "roleAdmin": "Администратор",
      "roleSuperAdmin": "Суперадминистратор",
      "device": "Устройство",
      "hasDevice": "Есть устройство",
      "noDevice": "Нет устройства"
    },
    "bulkActions": {
      "selected_one": "Выбран {{count}}",
      "selected_few": "Выбрано {{count}}",
      "selected_many": "Выбрано {{count}}",
      "selected_other": "Выбрано {{count}}",
      "deselectAll": "Снять выделение",
      "pushToTerminal": "Отправить на терминал",
      "pushing": "Отправка…",
      "activate": "Активировать",
      "activating": "Активация…",
      "deactivate": "Деактивировать",
      "deactivating": "Деактивация…",
      "delete": "Удалить",
      "deleting": "Удаление…"
    },
    "empty": {
      "noEmployees": "Сотрудников пока нет",
      "noResults": "По вашим фильтрам ничего не найдено. Попробуйте изменить поиск или фильтры.",
      "noEmployeesHint": "Нажмите + Новый сотрудник для ручного добавления или Импортировать всех с терминала.",
      "clearFilters": "Сбросить фильтры"
    },
    "failedToLoad": "Не удалось загрузить сотрудников",
    "failedToLoadHint": "Проверьте подключение и попробуйте снова.",
    "columns": {
      "employee": "Сотрудник",
      "role": "Роль",
      "pay": "Оплата",
      "devices": "Устройства",
      "status": "Статус",
      "biometrics": "Биометрия"
    },
    "privilegeLabels": {
      "superAdmin": "Суперадминистратор",
      "admin": "Администратор",
      "enroller": "Регистратор",
      "user": "Пользователь"
    },
    "confirm": {
      "bulkDelete": "Удалить {{count}} сотрудника(-ов) с терминала? Это действие нельзя отменить.",
      "deleteOne": "Удалить «{{name}}» (PIN {{pin}}) с терминала?"
    },
    "titlePullUsers": "Загрузить пользователей, фото и биометрические шаблоны с терминала",
    "titleRestoreDB": "Восстановить содержимое локальной БД и MinIO на терминал",
    "aria": {
      "searchEmployees": "Поиск сотрудников",
      "loadingEmployees": "Загрузка сотрудников…",
      "pushSelected": "Отправить выбранных сотрудников на терминал",
      "activateSelected": "Активировать выбранных сотрудников",
      "deactivateSelected": "Деактивировать выбранных сотрудников",
      "deleteSelected": "Удалить выбранных сотрудников",
      "bulkActions": "Массовые действия",
      "filterEmployees": "Фильтр сотрудников",
      "editEmployee": "Изменить сотрудника",
      "pushToTerminal": "Отправить на терминал",
      "deleteEmployee": "Удалить сотрудника"
    },
    "toasts": {
      "pushed_one": "{{count}} сотрудник отправлен на терминал.",
      "pushed_few": "{{count}} сотрудника отправлено на терминал.",
      "pushed_many": "{{count}} сотрудников отправлено на терминал.",
      "pushed_other": "{{count}} сотрудника отправлено на терминал.",
      "activated_one": "{{count}} сотрудник активирован.",
      "activated_few": "{{count}} сотрудника активировано.",
      "activated_many": "{{count}} сотрудников активировано.",
      "activated_other": "{{count}} сотрудника активировано.",
      "deactivated_one": "{{count}} сотрудник деактивирован.",
      "deactivated_few": "{{count}} сотрудника деактивировано.",
      "deactivated_many": "{{count}} сотрудников деактивировано.",
      "deactivated_other": "{{count}} сотрудника деактивировано.",
      "deleted_one": "{{count}} сотрудник удалён.",
      "deleted_few": "{{count}} сотрудника удалено.",
      "deleted_many": "{{count}} сотрудников удалено.",
      "deleted_other": "{{count}} сотрудника удалено.",
      "deleteFailed": "Не удалось удалить. Пожалуйста, попробуйте снова.",
      "exportFailed": "Не удалось экспортировать. Пожалуйста, попробуйте снова.",
      "importFailed": "Не удалось импортировать. Пожалуйста, попробуйте снова.",
      "someExportsFailed": "Часть экспортов завершилась с ошибкой.",
      "importQueued": "Поставлено в очередь {{count}} команд(ы) на {{devices}} устройстве(-ах).",
      "exportAllQueued": "Экспорт поставлен в очередь: {{employees}} сотрудников на {{devices}} устройстве(-ах).",
      "exportOneQueued": "Поставлено в очередь для {{name}} на {{devices}} устройстве(-ах)."
    },
    "biometricKinds": {
      "face": "Лицо",
      "fp": "Отпечаток",
      "palm": "Ладонь"
    }
  }
}
